import src from "IMAGE";
export default { src, width: 441, height: 343, blurWidth: 0, blurHeight: 0};
